import React, {KeyboardEvent, useEffect, useRef, useState} from "react";

import {ReactComponent as ArrowDownIcon} from "../../../../../assets/svg/General/arrowDownIcon.svg";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import BarLoader from "react-bar-loader";
import Card from "../../../../../models/card";
import {ReactComponent as CardIcon} from "../../../../../assets/svg/DashboardLayout/Sections/card.svg";
import DropdownLink from "../../../../../components/General/Dropdown/DropdownComponents/DropdownLink";
import {ReactComponent as EmptyXX} from "../../../../../assets/svg/EmptyXX.svg";
import SearchBar from "../../../Settings/Components/Searchbar/TeamMemebers/SearchBar";
import getAvatarColorClass from "../../../../../helpers/avatarColors";
import titleCase from "../../../../../hooks/titleCase";
import useClickOutside from "../../../../../hooks/useClickOutside";

interface CardDropdownProps {
	data: Array<Card>;
	noData?: boolean;
	showArrow?: boolean;
	isLoading?: boolean;
	isDisabled?: boolean;
	inputValue?: string;
	placeholder?: string;
	isSearchable?: boolean;
	clickAndClose?: boolean;
	isInputDisabled?: boolean;
	onClickFunc?: (e: Card) => void;
	onChangeFunc?: (e: string) => void;
}
function CardDropdown(props: CardDropdownProps): JSX.Element {
	const {
		data,
		noData = false,
		showArrow = false,
		isLoading,
		isDisabled,
		inputValue,
		placeholder,
		isSearchable = false,
		clickAndClose,
		isInputDisabled = false,

		onClickFunc,
		onChangeFunc,
	} = props;

	const [active, setActive] = useState(false);
	const [isHover, setIsHover] = useState<boolean>(false);
	const [searchTerm, setSearchTerm] = useState<string>("");
	const [filteredCards, setFilteredCards] = useState<Array<Card>>([]);

	const inputRef = useRef<HTMLInputElement | null>(null);

	const domNode = useClickOutside(() => setActive(false));
	/*
	useEffect(() => {
		if (!data) return;
		setOptions(data);
	}, [data]);
*/

	useEffect(() => {
		const accounts = data || [];
		const query = searchTerm.trim().toLowerCase();
		if (!isSearchable || !query.length) {
			setFilteredCards(accounts);
		} else {
			setFilteredCards(
				accounts.filter((item: Card) => {
					return item.name.toLowerCase().includes(query) || item.maskedPan.toLowerCase().includes(query);
				})
			);
		}
	}, [data, searchTerm, isSearchable]);

	/*const handleChangeSearchTerm = (e: string) => {
		setSearchTerm(e);
	};*/

	const handleKeypress = (event: KeyboardEvent<HTMLDivElement>) => {
		//it triggers by pressing the enter key
		if (event.key === "Enter") {
			inputRef?.current?.focus();
			setActive((prev) => !prev);
		}
	};

	return (
		<div className="relative flex h-full w-full flex-col items-center justify-start" ref={domNode}>
			<div
				className={
					`outline-none focus:outline-none relative h-12 w-full whitespace-nowrap rounded-lg border border-solid bg-transparent text-base capitalize leading-relaxed shadow-none transition-all duration-75 hover:text-blue focus:border-blue-focused focus:text-blue lg:hover:border-blue ` +
					`${
						inputValue && inputValue.length > 0
							? !active
								? "border-black-quin text-black-secondary hover:text-blue lg:hover:border-blue "
								: active
								? "border-blue"
								: "border-black-quin text-black-tertiary hover:text-blue lg:hover:border-blue"
							: active
							? "border-blue"
							: "border-black-quin text-black-tertiary"
					} ` +
					`${isHover ? "" : ""} ` +
					`${isInputDisabled ? "cursor-pointer" : "cursor-text"} `
				}
				onMouseEnter={() => setIsHover(true)}
				onMouseLeave={() => setIsHover(false)}
				onClick={() => {
					inputRef?.current?.focus();
					setActive(true);
				}}
				tabIndex={isDisabled ? -1 : 0}
				onKeyDown={handleKeypress}
			>
				<div className="relative flex h-full w-full items-center justify-between space-x-4 overflow-hidden whitespace-nowrap rounded-lg bg-white px-4 py-3 text-left text-base font-normal capitalize leading-relaxed">
					<input
						id={placeholder}
						name={placeholder}
						ref={inputRef}
						type="text"
						value={inputValue}
						onChange={(e) => {
							onChangeFunc && onChangeFunc(e.target.value);
						}}
						autoComplete="off"
						className={
							`focus:outline-none h-10 w-full placeholder-transparent focus:border-none ` +
							`${inputValue && inputValue.length > 0 ? "text-black-secondary " : active ? "text-black" : "text-black"} ` +
							`${isInputDisabled ? "pointer-events-none cursor-pointer" : ""} ` +
							`${isDisabled ? "text-black-quat " : ""} `
						}
						placeholder="john@doe.com"
					/>
					{isLoading && (
						<div className="space-x-none absolute bottom-0 left-0 z-10 w-full">
							<BarLoader color="#5466F9" height="3" />
						</div>
					)}
					{showArrow && (
						<span
							className={
								`duration flex transform items-center justify-end transition-transform ` +
								`${active ? "-rotate-180 text-blue" : "rotate-0"} ` +
								`${isDisabled ? "text-black-quat " : ""} `
							}
						>
							<ArrowDownIcon className="h-3.5 w-3.5 stroke-current" />
						</span>
					)}
				</div>
				<label
					htmlFor="text"
					className={
						`pointer-events-none absolute cursor-text duration-75 ease-in-out ` +
						`${
							active || (inputValue && inputValue?.length > 0)
								? "-top-2 left-2.5 bg-white px-1 text-xs "
								: "left-4 top-0 flex h-full items-center justify-center "
						} ` +
						`${active ? "text-blue" : ""} ` +
						`${active ? "text-blue" : inputValue && inputValue?.length > 0 ? "text-black-tertiary" : "text-black-tertiary"} ` +
						`${isHover ? "text-blue" : ""} ` +
						`${isDisabled ? "text-black-quat " : ""} `
					}
					onClick={() => inputRef?.current?.focus()}
				>
					{placeholder}
				</label>
			</div>

			<div
				className={
					`absolute right-0 top-full z-50 mt-1 h-fit max-h-224px w-full transform cursor-pointer overflow-hidden overflow-y-auto rounded-lg bg-white shadow  ` +
					`${!active ? "pointer-events-none scale-0 opacity-0" : "scale-100 opacity-100"} `
				}
			>
				{data && data.length > 0 && isSearchable && (
					<div className="flex h-14 w-full items-center justify-start px-4">
						<SearchBar placeholder="Search for account" value={searchTerm} onChange={setSearchTerm} />
					</div>
				)}
				{filteredCards.map((el, index) => (
					<DropdownLink
						onClick={() => {
							onClickFunc && onClickFunc(el);
							if (clickAndClose) return setActive((prev) => !prev);
						}}
						key={index}
						big
					>
						<div className="flex h-10 w-full items-center justify-start space-x-4 px-4">
							<div>
								<div className={`flex h-8 w-8 items-center justify-center rounded-full ${getAvatarColorClass(el.id)}`}>
									{el instanceof Card && <CardIcon className="stroke-current text-blue" />}
								</div>
							</div>
							<div className="flex h-full flex-col items-start justify-center">
								<span className="text-sm">{titleCase(el.name || "")}</span>
								<div className="flex flex-row items-center justify-start space-x-2 text-xs">
									<span>{el.maskedPan}</span>
								</div>
							</div>
						</div>
					</DropdownLink>
				))}
				{noData && (
					<>
						<div className="flex h-14 w-full flex-row items-center justify-center space-x-2 text-sm text-black-tertiary">
							<EmptyXX className="h-10 w-10" />
							<span>No Cards Found</span>
						</div>
					</>
				)}
			</div>
			{isDisabled && <div className="absolute left-0 top-0 z-10 h-full w-full cursor-default" />}
		</div>
	);
}

export default CardDropdown;
